export type SavedPaymentMethodKind = 'card' | 'blik_alias' | 'wallet'
export type SavedPaymentMethodStatus = 'active' | 'failed' | 'revoked' | 'expired'

export interface SavedPaymentMethod {
  id: string
  displayName: string
  kind: SavedPaymentMethodKind
  status: SavedPaymentMethodStatus
  cardMask?: string | null
  cardValidityDate?: string | null
  cardIssuer?: string | null
  operator?: string | null
  companyName?: string | null
  lastChargeAt?: string | null
  failedAttempts?: number | null
  lastError?: string | null
  consentAt?: string | null
  isDefault: boolean
  isMandate: boolean
}

export const sortSavedMethods = (list: SavedPaymentMethod[] = []) =>
  [...list].sort((a, b) =>
    Number(b.isDefault) - Number(a.isDefault) ||
    Number(b.status === 'active') - Number(a.status === 'active'))
